import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { TablePaginationParams } from '../../../components/core-v2/molecules/table-pagination'
import { PATH } from '../../../const'
import { useUser } from '../../../utilities/hooks/useUser'
import TradesLayout from '../../layout/tradesLayout'
import { getUserDisplayInfo } from '../../tradebuilder-v2/util/user'
import { actions as rawActions, TradeSearchFilter } from '../state/draft-trades-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'

export const DraftTradesSmart = () => {
  const { data: user } = useUser()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const state = useAppSelector(state => state.draftTrades)
  const actions = useActions(rawActions)
  const paginationParams: TablePaginationParams = {
    pageNumber: state.query.PageNumber,
    pageSize: state.query.PageSize,
    totalRows: state.numTotalTrades
  }
  useEffect(() => {
    actions.init()
  }, [actions])

  const userInfo = getUserDisplayInfo(user)

  const onStatusChange = useCallback(() => {
    dispatch(actions.refreshTrades())
  }, [dispatch, actions])

  const onPaginationChange = (updatedPagination: TablePaginationParams) => {
    actions.setPage(updatedPagination)
  }

  const onFilterChange = (updatedFilter: TradeSearchFilter) => {
    actions.setServerFilter(updatedFilter)
  }

  const onDelete = (accountId: string) => {
    actions.deleteDraftTrade(accountId)
    navigate(PATH.trades)
  }

  return (
    <TradesLayout
      accounts={state.accounts}
      filter={state.filter}
      isLoading={state.isLoading}
      paginationParams={paginationParams}
      totalNumAccounts={state.numTotalTrades}
      userInfo={userInfo}
      onDelete={onDelete}
      onFilterChange={onFilterChange}
      onPaginationChange={onPaginationChange}
      onStatusChange={onStatusChange}
    />
  )
}
